import React, { useRef, useState } from "react";
import { FaEraser, FaUpload } from "react-icons/fa6";
import { MdInsertChart } from "react-icons/md";

const PWIInsertionn = () => {
  const inputRefs = useRef([]);
  const urlPrefix = process.env.REACT_APP_URL_PREFIX; // Fallback URL
  const sections = [
    "MKP/ALD",
    "BINA",
    "ET",
    "MDVK",
    "NKJ/BSP",
    "MHDA/DHN",
    "AGD",
    "OHAN",
    "KEQ",
    "KTKD",
  ];
  const rakeTypes = ["JUMBO", "BOXN"];
  const fields = [
    "to_value",
    "ho_value",
    "to_loaded",
    "to_empty",
    "ho_loaded",
    "ho_empty",
    "to_intensive",
    "to_nonintensive",
  ];

  const createInitialRows = () => {
    const rows = [];
    sections.forEach((section) => {
      rakeTypes.forEach((type) => {
        const row = { section, rake_type: type };
        fields.forEach((field) => {
          row[field] = "";
        });
        rows.push(row);
      });
    });
    return rows;
  };

  const [rows, setRows] = useState(createInitialRows());
  const [reportDate, setReportDate] = useState(() =>
    new Date().toISOString().slice(0, 10)
  );

  const handleInputChange = (index, field, value) => {
    const updated = [...rows];
    const { section, rake_type } = updated[index];

    if (field === "to_value" || field === "ho_value") {
      updated.forEach((row) => {
        if (row.section === section) {
          row[field] = value;
        }
      });
    } else {
      updated[index][field] = value;
    }

    setRows(updated);
  };

  const handleSubmit = async () => {
    const updatedRows = rows.map((row) => ({
      ...row,
      interchange_date: reportDate,
    }));

    try {
      const response = await fetch(`${urlPrefix}insert/pointwiseInterchange`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedRows),
      });

      if (!response.ok) {
        alert(
          "This record already exists for this date. Please check date and try again."
        );
        throw new Error("Network response was not ok");
      }

      const result = await response.json();

      setRows(createInitialRows());
      alert("success");
    } catch (error) {
      console.error("Submission error:", error);
    }
  };

  const calsum = () => {
    const sums = {
      JUMBO: {},
      BOXN: {},
    };

    rakeTypes.forEach((tp) => {
      fields.forEach((fd) => {
        let sum = 0;

        rows.forEach((row) => {
          if (row.rake_type === tp) {
            sum += Number(row[fd]);
          }
        });

        sums[tp][fd] = sum;
      });
    });

    return sums;
  };

  const rakeTypeSums = calsum();

  return (
    <div className=" container">
      <div className="row text-center papaDiv">
        {" "}
        <h5 className="p-2 ">
          <MdInsertChart />
          Point-Wise Inter Change Insertion
        </h5>
        <h5>
          inserting data in <b style={{ color: "red" }}>"PWI"</b> table
        </h5>
      </div>
      <div className="papaDiv">
        <div>
          <div className="d-flex align-items-center justify-content-center m-1 ">
            <label className="me-2 fw-bold">Select Date:</label>
            <input
              type="date"
              className="form-control w-auto"
              value={reportDate}
              onChange={(e) => setReportDate(e.target.value)}
            />
          </div>
          <div className="table-responsive ">
            <table className="table table-bordered table-striped">
              <thead className="table-dark">
                <tr>
                  <th>Sno.</th>
                  <th>Section</th>
                  <th>Rake Type</th>
                  {fields.map((field) => (
                    <th key={field}>
                      {(field.charAt(0).toUpperCase() + field.slice(1)).replace(
                        "_",
                        " "
                      )}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {rowIndex % 2 === 0 && (
                      <td rowSpan={2} className="text-center">
                        {rowIndex / 2 + 1}
                      </td>
                    )}

                    {/* <td>{rowIndex % 2 === 0 ? row.section : ""}</td> */}
                    {rowIndex % 2 === 0 && (
                      <td className="text-center" rowSpan={2}>
                        {row.section}
                      </td>
                    )}
                    <td>{row.rake_type}</td>
                    {fields.map((field, colIndex) => {
                      const inputIndex = `${rowIndex}-${colIndex}`;
                      return (
                        <td key={field}>
                          <input
                            style={{
                              height: "26px",
                              padding: "2px 6px",
                              fontSize: "0.8rem",
                            }}
                            type="number"
                            className="form-control"
                            value={row[field] || 0}
                            onChange={(e) =>
                              handleInputChange(
                                rowIndex,
                                field,
                                Number(e.target.value)
                              )
                            }
                            disabled={
                              (field === "to_value" || field === "ho_value") &&
                              rowIndex % 2 === 1
                            }
                            ref={(el) => {
                              inputRefs.current[inputIndex] = el;
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter" || e.key === "ArrowDown") {
                                e.preventDefault();
                                const nextRow = rowIndex + 2;
                                const nextInput =
                                  inputRefs.current[`${nextRow}-${colIndex}`];
                                if (nextInput) nextInput.focus();
                              }
                              if (e.key === "ArrowUp") {
                                e.preventDefault();
                                const prevRow = rowIndex - 2;
                                const prevInput =
                                  inputRefs.current[`${prevRow}-${colIndex}`];
                                if (prevInput) prevInput.focus();
                              }
                              if (e.key === "ArrowRight") {
                                e.preventDefault();
                                const nextCol = colIndex + 1;
                                const nextInput =
                                  inputRefs.current[`${rowIndex}-${nextCol}`];
                                if (nextInput) nextInput.focus();
                              }
                              if (e.key === "ArrowLeft") {
                                e.preventDefault();
                                const prevCol = colIndex - 1;
                                const prevInput =
                                  inputRefs.current[`${rowIndex}-${prevCol}`];
                                if (prevInput) prevInput.focus();
                              }
                            }}
                          />
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* <div className=" table-responsive">
            <table className="table table-bordered table-striped mb-4 p-5  ">
              <thead className="table-light"> */}
          <div className="table-responsive-sm">
            <table className="table table-bordered table-striped">
              <thead className="table-light">
                <tr>
                  <th
                    colSpan={12}
                    className="fs-4 fw-semibolder border bg-dark text-white text-center "
                  >
                    {" "}
                    Total
                  </th>{" "}
                </tr>
                <tr>
                  <th>Sr no.</th>

                  <th>Rake Type</th>
                  {fields.map((field) => (
                    <th key={field}>
                      {" "}
                      {(field.charAt(0).toUpperCase() + field.slice(1)).replace(
                        "_",
                        " "
                      )}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rakeTypes.map((type, index) => (
                  <tr key={(type, index)}>
                    <td className="fw-bold">{index + 1}</td>

                    <td className="fw-bold">{type}</td>
                    {fields.map((field) => (
                      <td key={field}>{rakeTypeSums[type][field]}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="text-center">
            <button
              className="btn btn-outline-danger px-5 me-2"
              onClick={() => setRows(createInitialRows())}
            >
              <FaEraser /> Clear All
            </button>{" "}
            <button
              className="btn btn-outline-success px-5"
              onClick={handleSubmit}
            >
              <FaUpload /> Upload
            </button>
          </div>
        </div>{" "}
      </div>
    </div>
  );
};

export default PWIInsertionn;
